module.exports = __webpack_public_path__ + "static/media/4.7a8b36c0.jpg";